package com.shadowings.gero.data.lessons.chapter7
import com.shadowings.gero.data.lessons.chapter5.getEndVerb1QuizContent


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_title_intro_vso
import gero.composeapp.generated.resources.exp_content_intro_vso_1
import gero.composeapp.generated.resources.exp_content_intro_vso_2
import gero.composeapp.generated.resources.exp_content_intro_vso_3
import gero.composeapp.generated.resources.exp_content_intro_vso_4
import gero.composeapp.generated.resources.exp_content_intro_vso_5
import gero.composeapp.generated.resources.exp_content_intro_vso_6
import gero.composeapp.generated.resources.exp_content_intro_vso_7
import gero.composeapp.generated.resources.exp_content_intro_vso_8

fun getIntroVsoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_2,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_3,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_4,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_5,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_7,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso,
            content = Res.string.exp_content_intro_vso_8,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getIntroVsoQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return getEndVerb1QuizContent(hiero, words, languageCode)
}
